import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  DateRangeParameterDTO,
  FalseRecordingsReportParameterDTO,
  ParkerRegistrationType,
} from '../../../../../base/models/models.swagger.generated';
import { UntypedFormBuilder } from '@angular/forms';
import { FalseRecordingReportService } from '../false-recording-report.service';
import { ClientService } from '../../../../../base/services/client/client.service';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { SaveOptions } from '../../../reports-footer/save-options';
import { reportsRoute } from '../../../../../core/routing/route-names';
import { Router } from '@angular/router';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { DateTime } from 'luxon';
import { TranslateModule } from '@ngx-translate/core';
import { FalseRecordingFormComponent } from '../false-recording-form/false-recording-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-false-recording-report',
    templateUrl: './false-recording-report.component.html',
    styleUrls: ['./false-recording-report.component.scss'],
    imports: [
        TitleBarComponent,
        FalseRecordingFormComponent,
        GridModule,
        ReportsFooterComponent,
        TranslateModule,
    ]
})
export class FalseRecordingReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public data: DataManager;
  public filterForm = this.fb.group({
    startDate: [DateTime.now().startOf('month').toJSDate()],
    endDate: [DateTime.now().endOf('month').toJSDate()],
    zoneId: [null],
    agent: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(private clientService: ClientService,
              private fb: UntypedFormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private falseRecordingReportService: FalseRecordingReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.falseRecordingReportService, this.spinnerService),
    });

    if (this.selectedClient) {
      this.searchReports();
    }
  }

  public searchReports(): void {
    this.falseRecordingReportService.falseRecordingsReportParameters = this.createFalseRecordingReportParameterDTO();
    try {
      this.grid?.refresh();
    } catch (e) {
      // Ignore error when grid is in transition state
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();

    const falseRecordingsReportParameterDTO = this.createFalseRecordingReportParameterDTO();

    this.falseRecordingReportService.exportReport(falseRecordingsReportParameterDTO, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatParkerRegistrationType(direction: ParkerRegistrationType): string {
    return 'i18n.domain.parker-registration.ParkerRegistrationType.' + ParkerRegistrationType[direction];
  }

  private createFalseRecordingReportParameterDTO(): FalseRecordingsReportParameterDTO {
    return new FalseRecordingsReportParameterDTO({
      dateRange: new DateRangeParameterDTO({
        startDate: DateTime.fromJSDate(this.filterForm.get('startDate').value).startOf('day').toFormat('yyyy-MM-dd'),
        endDate: DateTime.fromJSDate(this.filterForm.get('endDate').value).startOf('day').toFormat('yyyy-MM-dd'),
      }),
      zoneId: this.filterForm.get('zoneId').value,
      agentId: this.filterForm.get('agent').value,
    });
  }

}
